import { render, staticRenderFns } from "./LayoutSite.vue?vue&type=template&id=7d156baa"
import script from "./LayoutSite.vue?vue&type=script&lang=ts"
export * from "./LayoutSite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports